import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendarDays: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-days"} maskId="square-filled-radius-0-stroke-1-IconCalendarDays"><path fillRule="evenodd" clipRule="evenodd" d="M3 3V21H21V3H3ZM8.5 11H7V12.5H8.5V11ZM8.5 15.5H7V17H8.5V15.5ZM11.25 15.5H12.75V17H11.25V15.5ZM12.75 11H11.25V12.5H12.75V11ZM15.5 11H17V12.5H15.5V11ZM20 4H4V7H20V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendarDays;
